import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const propTypes = {
  /**
   * Alignment of buttons inside the group
   */
  alignment: PropTypes.oneOf(['center', 'left', 'right', 'spread']),
  /**
   * If `true`, buttons inside this group will be displayed in "block" style (stacked vertically
   * and filling the width of the container). If either `small` or `medium`, buttons will be
   * displayed in block style in viewports matching that breakpoint or smaller.
   */
  block: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['small', 'medium'])]),
  /**
   * When in block style, buttons can either stack in "normal" or "reverse" order.
   * Defaults to normal.
   */
  blockDirection: PropTypes.oneOf(['normal', 'reverse']),
  /**
   * Buttons to display inside the group
   */
  children: PropTypes.node,
  /**
   * Additional classes to be added to the root element
   */
  className: PropTypes.string
};
function FlexButtonGroup(_ref) {
  let {
    alignment = 'center',
    className,
    children,
    block,
    blockDirection
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'asc-flex-btn-group', `asc-flex-btn-group--${alignment}`, {
      'asc-flex-btn-group--block': block === true,
      [`asc-flex-btn-group--block-${block}`]: typeof block === 'string',
      'asc-flex-btn-group--block-reverse': blockDirection === 'reverse'
    })
  }, children);
}
FlexButtonGroup.propTypes = propTypes;
export default FlexButtonGroup;